<template>
    <select class="form-control form-control-sm" data-placeholder="Stagione"  v-model="localValue">
        <option v-for="stagione in $root.arrayStagioni" v-bind:value="stagione.ID_OPZIONE_TIPOLOGICA" v-bind:key="stagione.ID_OPZIONE_TIPOLOGICA">{{stagione.DESCRIZIONE}}</option>														
    </select>
</template>
<script>


import { computed } from 'vue'


export default {
    name:"SelectStagioni",
    components:{
   
    },
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: [String, Number]
        },        
    },
    //props:['campo','inputgroup'],
    setup(props, { emit }) {
        const localValue = computed({
            get: () => props.modelValue,
            set: (val) => emit('update:modelValue', val),
        });
        return { localValue };
    }, 
    computed:{
     
    }
}
</script>

